import React from 'react'

import RefundModal from "../../modal/Refund";

import AuthManager from "../../../../utils/AuthManager";

import Div from "../../common/Div"

export default class Refund extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      submission: props.submission,
      currentUser: AuthManager.currentUser,
      showRefundModal: false
    }
  }

  render() {
    let {
      isLoading,
      submission,
      showRefundModal
    } = this.state

    if(!submission.mrn || !submission.form.type === "ais" || submission.status !== "released") {
      return null
    }

    const refundApplicationStatus = submission.refund_application_status

    if(refundApplicationStatus === "processing" || refundApplicationStatus === "accepted"){
      return null
    }

    return (
      <Div disabled={isLoading}>
        <button
          className="btn btn-sm btn-outline-primary btn-submission-action"
          onClick={() => this.setState({showRefundModal: true})}
        >
          Request Refund
        </button>
        {
          showRefundModal &&
          <RefundModal
            show={showRefundModal}
            submission={submission}
            onRefundApplicationSent={() => {
              this.setState({showRefundModal: false})
              this.props.onRefundApplicationSent()
            }}
            onHide={() => this.setState({showRefundModal: false})}
          />
        }
      </Div>
    )
  }
}

Refund.defaultProps = {

}
